import React from "react";
import { usePortalAuth } from "../../lib/portal-auth-context";
import {
  DataTable,
  PageHeader,
  StatusPill,
  formatDate,
  formatMXN,
  useFetchList,
} from "./portal-ui";

export default function PortalOrders() {
  const { api } = usePortalAuth();
  const { items, loading } = useFetchList(api, "/orders");

  return (
    <div data-testid="portal-orders-page">
      <PageHeader
        eyebrow="Pedidos"
        title="Mis pedidos"
        subtitle="Órdenes confirmadas, en curso y entregadas."
      />
      <DataTable
        testId="portal-orders-table"
        loading={loading}
        rows={items}
        emptyMsg="Aún no hay pedidos para tu cuenta."
        columns={[
          { key: "created_at", label: "Fecha", render: (r) => formatDate(r.created_at) },
          { key: "id", label: "Orden", render: (r) => (r.id || "").slice(0, 8).toUpperCase() },
          { key: "items_count", label: "Items", render: (r) => r.items_count ?? 0 },
          { key: "total", label: "Total", render: (r) => formatMXN(r.total) },
          { key: "status", label: "Estado", render: (r) => <StatusPill value={r.status} /> },
        ]}
      />
    </div>
  );
}
